export class PerformanceMonitor {
  constructor(windowSize = 240) {
    this.windowSize = windowSize;
    this.samples = [];
    this.lastWarningAt = 0;
  }

  pushFrame(deltaMs) {
    if (deltaMs <= 0) {
      return;
    }
    this.samples.push(1000 / deltaMs);
    if (this.samples.length > this.windowSize) {
      this.samples.shift();
    }
  }

  snapshot() {
    if (this.samples.length === 0) {
      return {
        averageFps: 0,
        onePercentLow: 0,
        sampleCount: 0
      };
    }

    const sorted = [...this.samples].sort((a, b) => a - b);
    const avg = this.samples.reduce((acc, value) => acc + value, 0) / this.samples.length;
    const onePercentIndex = Math.max(0, Math.floor(sorted.length * 0.01) - 1);

    return {
      averageFps: avg,
      onePercentLow: sorted[onePercentIndex],
      sampleCount: this.samples.length
    };
  }
}
